
// src/reducers/sidebar-reducer.js

import {
  OPEN_SIDEBAR,
  CLOSE_SIDEBAR,
  DOCK_SIDEBAR,
  UNDOCK_SIDEBAR,
} from '../actions/sidebar'

const initialState = {
  open: true,
  docked: true,
}

export default function sidebarReducer(state = initialState, action = {}) {
  switch(action.type) {
  case OPEN_SIDEBAR:
    return Object.assign({}, state, {
      open: true
    })

  case CLOSE_SIDEBAR:
    return Object.assign({}, state, {
      open: false
    })

  case DOCK_SIDEBAR:
    return Object.assign({}, state, {
      docked: true
    })

  case UNDOCK_SIDEBAR:
    return Object.assign({}, state, {
      docked: false
    })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sidebar-reducer.js